export default "__VITE_ASSET__G9J1zUnv__"